import { Component, Input, ViewChild } from '@angular/core';
import VehiclePolicy from '../../../../../core/data/models/vehicle.policy.model';
import { DecimalPipe } from '@angular/common';
import Vehicle from '../../../../../core/data/models/vehicle.model';
import { CommonDetailComponent } from '../common-detail/common-detail.component';
import { PolicyDto } from '../common-detail/policyDto';

@Component({
  selector: 'app-vehicle-detail',
  imports: [CommonDetailComponent],
  providers: [DecimalPipe],
  templateUrl: './vehicle-detail.component.html',
  styleUrl: './vehicle-detail.component.css',
})
export class VehicleDetailComponent {
  dto: PolicyDto = {} as any;

  policySlob: string = '';
  policyNumber: string = '';
  vehicleInfoLabes: {
    label: string;
    attribute: keyof Vehicle;
    transfomer?: (value: any) => string;
  }[] = [
    {
      label: 'Tipo',
      attribute: 'type',
    },
    {
      label: 'Marca',
      attribute: 'make',
    },
    {
      label: 'Modelo',
      attribute: 'model',
    },
    {
      label: 'Año',
      attribute: 'year',
    },
    {
      label: 'Chasis',
      attribute: 'vinNumber',
    },
    {
      label: 'Placa',
      attribute: 'registrationNumber',
    },
    {
      label: 'Color',
      attribute: 'color',
    },
    {
      label: 'Uso',
      attribute: 'use',
    },
    {
      label: 'Valor',
      attribute: 'value',
      transfomer: (value) => {
        return `$${this.decimalPipe.transform(value, '1.0-0')}`;
      },
    },
  ];

  constructor(private decimalPipe: DecimalPipe) {}

  @Input() set slob(slob: string | null) {
    this.policySlob = slob || '';
  }

  @Input() set policy(policyNumber: string | null) {
    this.policyNumber = policyNumber || '';
  }

  @Input() set value(policies: VehiclePolicy[]) {
    if (policies && policies.length) {
      this.dto = {
        label: `${policies.length} vehículos`,
        searchLabel: 'Buscar por placa',
        emptyLabel: 'No tiene vehículos asociados a esta póliza',
        policies: policies.map((policy) => {
          return {
            infoLabels: this.vehicleInfoLabes.map((infoLabel) => {
              const value = policy.vehicleInfo[infoLabel.attribute];
              return {
                label: infoLabel.label,
                value: infoLabel.transfomer
                  ? infoLabel.transfomer(value)
                  : value,
              };
            }),
            cardContent: `
               <div class="d-flex align-items-center gap-1 my-1">
                  <span><strong>${policy.vehicleInfo.make} ${policy.vehicleInfo.model} - ${policy.vehicleInfo.color}</strong></span>
              </div>
              <div class="d-flex align-items-center gap-1 my-1">
                  ${policy.vehicleInfo.registrationNumber ? `<span>${policy.vehicleInfo.registrationNumber}</span>` : ''}
                  <span> ${policy.vehicleInfo.type}</span>
              </div>
              <div class="d-flex align-items-center gap-1 my-1">
                  <span>Valor asegurado:</span>
                  <strong class="text-primary text-colonial">$${this.decimalPipe.transform(policy.vehicleInfo.value, '1.0-0')}</strong>
              </div>

            `,
            coverages: policy.coverages,
            vehicleNumber: policy.vehicleInfo.vehicleNumber,
          };
        }),
        detailLabel: 'Información del vehículo',
        downloadCarnet: true,
        policyNumber: this.policyNumber,
      };
    }
  }
}
